export default defineAppConfig({
  ui: {
    colors: {
      primary: "primary",
      neutral: "slate",
      error: "red",
      success: "green",
      warning: "yellow",
    },
    input: {
      slots: {
        base: 'placeholder:text-slate-300'
      }
    }
  },
});
